import { Button } from "antd";
import React, { useState } from "react";

const MessageA15 = (props) => {
  const { inputValue } = props;
  const [onClick , setOnClick] = useState(false)
  console.log(inputValue)
  return (
    <div style={{ marginTop: "20px" }}>
    <>
      {props?.item?.text === "Submit" ||  props?.item?.text === "Remove Device"  ? (
        <Button
           className={!onClick ? "submit-btn  action-tab action-button" : "chat-label-select action-tab action-button " }
          // className={
          //   !onClick
          //     ? "chat-label action-tab action-button"
          //     : "chat-label-select action-tab"
          // }
          // style={{color : onClick && 'white'}}
          style={{ height: "26px", '!important': true }}
          id="main-tab1"
          ref={inputValue}
          disabled={props.disabled}
        >
          <span
            style={{
              color: props.disable && "grey",
            }}
            id="main-tab1"
            onClick={() => {
              const data = JSON.parse(localStorage.getItem("inputValue"));
              if (!props?.disable) {
                props.handleClick(props?.item?.code, data?.key1, null);
                props.setTextOnClick(
                  // data?.key1?.length > 1 ? data?.key1?.join(", ") : data?.key1
                  data?.key1
                );
                setOnClick(true)
              }
            }}
            className="volte-text"
          >
            {props?.item?.text }
          </span>
        </Button>
      ) : (
        <span
        className={
          !onClick
            ? "chat-label action-tab action-button"
            : "chat-label-select action-tab"
        }
          style={{ color: props.disable && "grey" }}
          id="main-tab1"
          onClick={() => {
            const data = JSON.parse(localStorage.getItem("inputValue"));
            if (!props.disable) {
              props.handleClick(props.item.code, data, null);
              props.setTextOnClick(props.item.text);
              setOnClick(true)
            }
          }}
        >
          {props.item.text}
        </span>
      )}
      </>
    </div>
  );
};

export default MessageA15;
